import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../Hooks/use-store";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DetailedResultsListening from "../components/Results/detailedReport/DetailedResultsListening";
import Frame from "../icons/Frame.svg";
import AiFeedbackQuestionDescription from "../components/common/aiFeedbackQuestionDescription";
import LockedIcon from "../icons/Lock.svg";
import { useRef, useEffect, useState } from "react";
import PlayIcon from "../icons/Pause.png";
import BoxTabs from "../components/common/boxTabs";
import RenderTable from "../components/Results/aiFeedback/tableQuestionResults";
import { getAnswerRender, getExactCorrectClassName, getTheAnswerStatement, getUserAnswerTextClassName, questionIdClassName } from "../utils";

interface AIFeedback {
  partType: string;
  qId: string;
  questionName: string;
  questionType: string;
  userAnswer: string;
  exactAnswer: string;
  isCorrect: boolean;
  isAttempted: boolean;
  isSelected: boolean;
  audio: string;
  table: Array<any>;
}

interface TabPanel {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = (props: TabPanel) => {
  const { children, index, value } = props;
  return (
    <div>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const ListeningResults = () => {
  const [value, setValue] = useState(0);
  const [aiFeedback, setAIFeedback] = useState<AIFeedback>({
    partType: "",
    qId: "",
    questionName: "",
    questionType: "",
    userAnswer: "",
    exactAnswer: "",
    isCorrect: false,
    isAttempted: false,
    isSelected: false,
    audio: "",
    table: [],
  });

  const navigate = useNavigate();
  const { resultsStoreListening, userStore, dashboardStore } = useStore();
  const { aiFeedbackData: data } = resultsStoreListening;
  const backHandler = () => {
    resultsStoreListening.isFreeTestCompletedClicked
      ? resultsStoreListening.viewResultsPage(false)
      : resultsStoreListening.viewResultsPage(true);
    navigate("/listening");
  };
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isAudio, setIsAudio] = useState(false);
  const progressWidth = 10;

  const handleTabs = (event: React.SyntheticEvent, newValue: number | null) => {
    if (newValue !== null) {
      setValue(newValue);
    }
  };

  const handleAIFeedback = (item: any, part: any, audio: string) => {
    if (
      item.questionType === "Multiple Choice (more than one answer)" &&
      Array.isArray(item.exactAnswer)
    ) {
      item.exactAnswer = item.exactAnswer.join(", ");
    }
    setAIFeedback((prevState) => ({
      ...prevState,
      partType: part,
      // paragraph:data["part1"],
      qId: item.qId,
      questionName: item.qName,
      questionType: item.questionType,
      userAnswer: item.userAnswer,
      exactAnswer: item.exactAnswer,
      isCorrect: item.isCorrect,
      isSelected: true,
      isAttempted: item.isAttempted,
      audio: audio,
      table: item.table,
    }));
  };

  const renderHtml = (aiFeedback: AIFeedback) => {
    const replacedTextParts = aiFeedback?.questionName?.split("{}");

    return (
      <span>
        {aiFeedback.qId}.
        {replacedTextParts?.map((part, index) => (
          <React.Fragment key={aiFeedback.qId}>
            {index > 0 && (
              <strong
                className={`font-bold ${
                  aiFeedback.isCorrect ? "text-[#59A51A]" : "text-[#DB3555]"
                }`}
              >
                {aiFeedback.userAnswer ? aiFeedback.userAnswer : "_________"}
              </strong>
            )}
            {part}
          </React.Fragment>
        ))}
      </span>
    );
  };

  const startHandler = () => {
    dashboardStore.setProfilePageTabIndex(1);
    navigate("/profile");
  };

  useEffect(() => {
    if (audioRef.current) {
      // Assuming the progressWidth is a percentage (0-100)
      const volumeLevel = progressWidth / 100;
      audioRef.current.volume = volumeLevel;
      console.log(audioRef.current.volume, "audioRef.current.volume");
    }
  }, [progressWidth]);
  useEffect(() => {
    setIsAudio(true);
    return () => {
      setIsAudio(false);
    };
  }, [aiFeedback.audio]);

  return (
    <div className="ml-49 w-[95%] mx-auto">
      <button
        onClick={backHandler}
        className="text-[#3C424C] font-normal text-lg cursor-pointer flex flex-row"
      >
        <img src={Frame} alt="arrow" />{" "}
        <span className="ml-4 font-semibold">Test Results Listening</span>
      </button>
      <BoxTabs
        value={value}
        handleTabs={handleTabs}
        tabLabels={[
          { name: "Result", id: 1 },
          { name: "AI Feedback", id: 2 },
        ]}
      >
        <CustomTabPanel index={0} value={value}>
          {resultsStoreListening.isResultsLoading ? (
            <div className="bg-[#E3E5E9]-500 border-2 rounded-[8px] w-[90%]   h-[20rem] my-8 shimmer"></div>
          ) : (
            <DetailedResultsListening />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <div className="relative">
            <div className="flex gap-4">
              <div className="border font-avenir border-gray-300 rounded-md bg-white w-1/3 min-h-[70vh]">
                <h1 className="bg-[#F8F9FA] p-4 border rounded-md rounded-b-none border-b-gray-300 font-medium text-[#292D35] text-lg">
                  Section-wise Questions
                </h1>
                <div className="flex gap-4 px-4 py-2 items-center border-b border-b-gray-300">
                  <div className="flex items-center gap-1">
                    {/* <input type="checkbox" /> */}
                    <div className="w-4 h-4 border-2 border-[#59A51A] rounded"></div>
                    <p className="text-[1rem] my-auto">Correct</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {/* <input type="checkbox" /> */}
                    <div className="w-4 h-4 border-2 border-[#DB3555] rounded"></div>
                    <p className="text-[1rem] my-auto">Incorrect</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {/* <input type="checkbox" /> */}
                    <div className="w-4 h-4 border-2 border-[#737E93] rounded"></div>
                    <p className="text-[1rem] my-auto">Not attempted</p>
                  </div>
                </div>
                {data["part1"] && (
                  <div className="mt-3 px-4">
                    <h1 className="mb-2 font-medium text-[#292D35] text-base">
                      Part 1
                    </h1>
                    <div className="flex flex-wrap gap-4 mb-4 w-full ">
                      {data?.part1?.questions?.length > 0 &&
                        data?.part1?.questions?.map((item: any) => {
                          return (
                            <button
                              key={item.qId}
                              className={`${questionIdClassName(
                                item,
                                aiFeedback.qId
                              )}  px-3 py-1 font-avenir cursor-pointer rounded-md `}
                              onClick={() =>
                                handleAIFeedback(
                                  item,
                                  "part1",
                                  data?.part1?.audio
                                )
                              }
                            >
                              {item.qId}
                            </button>
                          );
                        })}
                    </div>
                  </div>
                )}

                {data["part2"] && (
                  <div className="mt-3 px-4">
                    <h1 className="mb-2 font-medium text-[#292D35] text-base">
                      Part 2
                    </h1>
                    <div className="flex flex-wrap gap-4 mb-4">
                      {data?.part2?.questions?.length > 0 &&
                        data?.part2?.questions?.map((item: any, index: any) => {
                          return (
                            <button
                              key={item.qId}
                              className={`${questionIdClassName(
                                item,
                                aiFeedback.qId
                              )}  px-3 py-1 font-avenir cursor-pointer rounded-md `}
                              onClick={() =>
                                handleAIFeedback(
                                  item,
                                  "part2",
                                  data?.part2?.audio
                                )
                              }
                            >
                              {item.qId}
                            </button>
                          );
                        })}
                    </div>
                  </div>
                )}

                {data["part3"] && (
                  <div className="mt-3 px-4">
                    <h1 className="mb-2 font-medium text-[#292D35] text-base">
                      Part 3
                    </h1>
                    <div className="flex flex-wrap gap-4 mb-4">
                      {data?.part3?.questions?.length > 0 &&
                        data?.part3?.questions?.map((item: any, index: any) => {
                          return (
                            <button
                              key={item.qId}
                              className={`${questionIdClassName(
                                item,
                                aiFeedback.qId
                              )}  px-3 py-1 font-avenir cursor-pointer rounded-md `}
                              onClick={() =>
                                handleAIFeedback(
                                  item,
                                  "part3",
                                  data?.part3?.audio
                                )
                              }
                            >
                              {item.qId}
                            </button>
                          );
                        })}
                    </div>
                  </div>
                )}

                {data["part4"] && (
                  <div className="mt-3 px-4">
                    <h1 className="mb-2 font-medium text-[#292D35] text-base">
                      Part 4
                    </h1>
                    <div className="flex flex-wrap gap-4 mb-4">
                      {data?.part4?.questions?.length > 0 &&
                        data?.part4?.questions?.map((item: any) => {
                          return (
                            <button
                              key={item.qId}
                              className={`${questionIdClassName(
                                item,
                                aiFeedback.qId
                              )}  px-3 py-1 font-avenir cursor-pointer rounded-md `}
                              onClick={() =>
                                handleAIFeedback(
                                  item,
                                  "part4",
                                  data?.part4?.audio
                                )
                              }
                            >
                              {item.qId}
                            </button>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>

              <div className="border font-avenir border-gray-300 rounded-md bg-white w-8/12">
                <h1 className="bg-[#F8F9FA] font-avenir p-4 border rounded-md rounded-b-none border-b-gray-300 font-medium text-[#292D35] text-lg">
                  Analysis
                </h1>
                {!aiFeedback.qId ? (
                  <div className="flex justify-center items-center h-full font-avenir">
                    {" "}
                    Please Select the Question to get the feedback
                  </div>
                ) : (
                  <div className="flex font-avenir justify-between w-full p-4 text-xs ">
                    <div className="w-1/2 pr-5">
                      <h1 className="text-xs text-[#737E93] uppercase mb-2 flex">
                        <span className="mt-2">
                          Academic Listening {aiFeedback.partType}
                        </span>
                        <button
                          className="flex ml-4 items-center cursor-pointer "
                          onClick={() => setIsAudio(!isAudio)}
                        >
                          {" "}
                          {isAudio ? (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="mr-2 text-red-600"
                              >
                                <path
                                  d="M14.5791 2.32579C14.4529 2.26433 14.3121 2.23948 14.1726 2.25406C14.033 2.26865 13.9004 2.32208 13.7897 2.40829L7.24219 7.49985H3C2.60218 7.49985 2.22064 7.65788 1.93934 7.93919C1.65804 8.22049 1.5 8.60202 1.5 8.99985V14.9998C1.5 15.3977 1.65804 15.7792 1.93934 16.0605C2.22064 16.3418 2.60218 16.4998 3 16.4998H7.24219L13.7897 21.5914C13.9005 21.6775 14.0332 21.7309 14.1728 21.7453C14.3124 21.7597 14.4533 21.7347 14.5793 21.6731C14.7054 21.6115 14.8117 21.5157 14.8861 21.3967C14.9604 21.2777 14.9999 21.1402 15 20.9998V2.99985C15 2.85934 14.9606 2.72166 14.8861 2.60248C14.8117 2.48331 14.7053 2.38743 14.5791 2.32579ZM3 8.99985H6.75V14.9998H3V8.99985ZM13.5 19.4661L8.25 15.3833V8.61641L13.5 4.5336V19.4661ZM18.5625 9.5211C19.1657 10.2059 19.4986 11.0872 19.4986 11.9998C19.4986 12.9125 19.1657 13.7938 18.5625 14.4786C18.43 14.6242 18.2456 14.7119 18.049 14.7227C17.8524 14.7335 17.6595 14.6666 17.5118 14.5364C17.3642 14.4062 17.2736 14.2231 17.2597 14.0268C17.2458 13.8304 17.3097 13.6364 17.4375 13.4867C17.7992 13.0759 17.9988 12.5473 17.9988 11.9998C17.9988 11.4524 17.7992 10.9238 17.4375 10.513C17.3097 10.3633 17.2458 10.1693 17.2597 9.97293C17.2736 9.77656 17.3642 9.59353 17.5118 9.46333C17.6595 9.33314 17.8524 9.26623 18.049 9.27703C18.2456 9.28784 18.43 9.3755 18.5625 9.5211ZM23.25 11.9998C23.2511 13.845 22.5711 15.6257 21.3403 17.0005C21.2067 17.145 21.0216 17.2313 20.825 17.2406C20.6284 17.2499 20.436 17.1815 20.2893 17.0503C20.1426 16.919 20.0535 16.7353 20.041 16.5388C20.0286 16.3424 20.0939 16.1489 20.2228 16.0002C21.2066 14.9001 21.7505 13.4761 21.7505 12.0003C21.7505 10.5245 21.2066 9.1005 20.2228 8.00047C20.1553 7.9274 20.103 7.84163 20.0689 7.74815C20.0349 7.65466 20.0197 7.55533 20.0245 7.45595C20.0292 7.35657 20.0536 7.25911 20.0963 7.16926C20.1391 7.07942 20.1993 6.99897 20.2734 6.93261C20.3475 6.86625 20.4341 6.81531 20.5281 6.78274C20.6222 6.75018 20.7217 6.73665 20.821 6.74293C20.9203 6.74922 21.0173 6.7752 21.1065 6.81936C21.1957 6.86352 21.2751 6.92498 21.3403 7.00016C22.5714 8.37436 23.2515 10.1549 23.25 11.9998Z"
                                  fill="#3C424C"
                                />
                              </svg>
                              <p className="flex items-center lowercase">
                                Audio is playing
                              </p>
                            </>
                          ) : (
                            <img src={PlayIcon} alt="playIcon" />
                          )}
                        </button>

                        {isAudio && (
                          <audio
                            ref={audioRef}
                            autoPlay
                            src={aiFeedback.audio}
                            onEnded={() => setIsAudio(false)}
                          >
                            <track kind="captions" label="English" default />
                          </audio>
                        )}
                      </h1>
                      <AiFeedbackQuestionDescription
                        questionType={aiFeedback.questionType}
                      />
                      {aiFeedback.questionType !== "Table Completion" ? (
                        <div>
                          <p className="text-[#292D35] text-sm mb-2">
                            {renderHtml(aiFeedback)}
                          </p>
                          <p className="text-[#737E93] font-avenir uppercase mb-2">
                            Your Answer
                          </p>
                          <p
                            className={`${getUserAnswerTextClassName(
                              aiFeedback
                            )}font-avenir text-sm`}
                          >
                            {getAnswerRender(aiFeedback,"userAnswer")}
                          </p>
                          <p className={`text-[#737E93] uppercase mb-2 mt-5`}>
                            Correct Answer
                          </p>
                          <p className={`text-[#59A51A] font-avenir text-sm`}>
                            {getAnswerRender(aiFeedback,"exactAnswer")}
                          </p>
                          <div
                            className={` mt-10 ${getExactCorrectClassName(
                              aiFeedback
                            )}  rounded-md px-3 py-2 w-3/4 font-avenir`}
                          >
                            {getTheAnswerStatement(aiFeedback)}
                          </div>
                        </div>
                      ) : (
                        <div>
                          {aiFeedback.table && (
                            <RenderTable tableA={aiFeedback} data={data} />
                          )}
                          <p className="text-[#737E93] uppercase my-2 mt-10 font-semibold text-sm font-avenir">
                            Your Answer
                          </p>
                          <p
                            className={`${getUserAnswerTextClassName(
                              aiFeedback
                            )}`}
                          >
                            {aiFeedback.userAnswer !== ""
                              ? aiFeedback.userAnswer
                              : "Not Answered"}
                          </p>
                          <p
                            className={`text-[#737E93] uppercase mb-2 mt-5 font-semibold text-sm font-avenir`}
                          >
                            Correct Answer
                          </p>
                          <p className={`text-[#59A51A] text-sm font-avenir`}>
                            {aiFeedback.exactAnswer}
                          </p>
                          <div
                            className={` mt-10 ${getExactCorrectClassName(
                              aiFeedback
                            )}  rounded-md px-3 py-2 w-3/4 font-avenir`}
                          >
                            {getTheAnswerStatement(aiFeedback)}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {!userStore.isProUser && (
            <div
              className="flex flex-col absolute top-0 left-0 min-h-screen  right-0 rounded-b-[16px] bg-[#2D293566] w-full h-full justify-center items-center"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <div>
                <img src={LockedIcon} alt="lock" />
              </div>
              <div className="text-[#FFFF] text-center">
                {" "}
                <p>
                  Get a plan to check your AI feedback. It shows pronunciation,
                  fluency and relevance of each sentence you speak
                </p>
              </div>
              <button
                className="mx-auto bg-white rounded-full px-4 py-2 font-medium text-[#FF495C] cursor-pointer mt-5"
                onClick={startHandler}
              >
                CHECKOUT OUR PLANS
              </button>
            </div>
          )}
        </CustomTabPanel>
      </BoxTabs>
    </div>
  );
};

export default observer(ListeningResults);
